import {
  cptyIdOrTickerFormatter,
  dateFormat,
  formatQuantity,
  rateFormatter,
  rowValueFormatter,
} from "./commonFunctions";
import searchLogo from "../assets/images/searchLogo.svg";
import { status } from "./constants";
import _ from "lodash";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";

const markFormatter = (p: any) => {
  let mark:any;
  if (p?.value && !isNaN(p?.value) && _.isString(p.value)) {
    mark = parseInt(p.value);
  }
  else if (_.isNumber(p?.value)) {
    mark = p?.value;
  }
  if(mark){
    return Math.trunc(mark);
  }
  return "";
}
export const contractActivityColDef = [
  {
    headerName: "Act Id",
    field: "activity_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Version",
    field: "version",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Type",
    field: "loanet_txn_description",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 100,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    hide: false,
    field: "ticker",
    floatingFilter: false,
    editable: false,
    valueFormatter: cptyIdOrTickerFormatter,
    filterParams: {
      valueFormatter: cptyIdOrTickerFormatter,
    },
    tooltipField: "secName",
    filter: "agTextColumnFilter",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 100,
    width: 120,
    maxWidth: 180,
    suppressSizeToFit: false,
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "B/L",
    field: "bl",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cptyId",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    hide: true,
    valueFormatter: cptyIdOrTickerFormatter,
    filterParams: {
      valueFormatter: cptyIdOrTickerFormatter,
    },
    tooltipField: "cptyId",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cptyName",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    tooltipField: "cptyName",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Cusip",
    field: "secid",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "secid",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    filterParams: {
      allowedCharPattern: "\\d\\-\\,",
      numberParser: (text: any) => {
        return parseFloat(text.replace(",", ""));
      },
    },
  },
  {
    headerName: "Quantity",
    field: "quantity",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    tooltipField: "quantity",
    type: "rightAligned",
    editable: false,
    valueFormatter: formatQuantity,
    filterParams: {
      valueFormatter: formatQuantity,
    },
    cellStyle: function (params: any) {
      if (params.node.data.quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
   {
    headerName: "Mark",
    field: "mark",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agNumberColumnFilter",
    valueFormatter: markFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid #DFDFDF",
      }
    },
    minWidth: 70,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Value",
    field: "colValue",
    type: "rightAligned",
    valueFormatter: rowValueFormatter,
    filterParams: {
      valueFormatter: rowValueFormatter,
    },
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    tooltipField: "colValue",
    minWidth: 120,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    maxWidth: 120,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    floatingFilter: false,
    tooltipField: "rate",
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 70,
    maxWidth: 70,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  {
    headerName: "P/C",
    field: "profit_center",
    hide: true,
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 60,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "C/N",
    field: "coll_type",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Div",
    field: "div",
    floatingFilter: false,
    hide: true,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
      justifyContent: "flex-end",
    },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Term Date",
    field: "term_date",
    floatingFilter: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    tooltipField: "term_date",
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 110,
    maxWidth: 110,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Lnet Status",
    field: "processing_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 150,
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else if (params?.node?.data?.processing_status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 130,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Updated Date",
    field: "updatedDateStr",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 130,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "User Id",
    field: "user_id",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 100,
    maxWidth: 130,
    suppressSizeToFit: false,
  },
];
